import React, { createContext, useContext, useEffect, useState } from 'react'
import { authService } from '../services/authService'
import { authTokenStore } from '../lib/api'

const AuthContext = createContext({})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const bootstrap = async () => {
      const token = authTokenStore.get()
      if (!token) {
        setLoading(false)
        return
      }

      try {
        const me = await authService.me()
        setUser(me)
      } catch (error) {
        authService.logout()
      } finally {
        setLoading(false)
      }
    }

    bootstrap()
  }, [])

  const signIn = async (email, password) => {
    const signedInUser = await authService.login({ email, password })
    setUser(signedInUser)
    return signedInUser
  }

  const signUp = async (email, username, password) => {
    const registeredUser = await authService.register({ email, username, password })
    setUser(registeredUser)
    return registeredUser
  }

  const signOut = () => {
    authService.logout()
    setUser(null)
  }

  const updateProfile = async (updates) => {
    const updatedUser = await authService.updateProfile(updates)
    setUser(updatedUser)
    return updatedUser
  }

  const value = {
    user,
    userProfile: user,
    loading,
    profileLoading: false,
    signIn,
    signUp,
    signOut,
    updateProfile,
    isAuthenticated: !!user
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
